import _ from 'lodash';

export class RouteBuilder {
	constructor(collection) {
		this.collection = collection;
		this.segmentDelimiter = "&";
		this.assignmentDelimiter = "=";
		this.segmentOrder = [];
		this.paramMap = {};
	}

	getRoute() {
		var routeString = "";
		var paramArr = this._order(this.collection.toParamArray());
		_.each(paramArr, p => {
			// does p have a value that is not null, undefined or emptry string?
			// if it is, don't include it in the route
			if (p.value === null || p.value === undefined || p.value === "" ) {
				return;
			}

			// check if we've mapped the param id to a different key for the route
			var segmentId = this.paramMap[p.id] ? this.paramMap[p.id] : p.id;
			var segmentValue = p.value;

			let maybeNewSegment = _.indexOf(paramArr, p) === 0 ? "" : this.segmentDelimiter;
			routeString = routeString +
				maybeNewSegment +
				encodeURIComponent(segmentId) +
				this.assignmentDelimiter +
				encodeURIComponent(segmentValue)
		});

		return routeString;
	}

	_order(paramArr) {
		// if no segment order specified, just return original array
		if (!this.segmentOrder.length) {
			return paramArr;
		}

		// create an object where ids are keys
		var groups = _.groupBy(paramArr, p => p.id);

		let ordered = _.map(this.segmentOrder, seg => {
			// if the id in the segmentOrder matches the id in the group
			// add it to the map
			if (groups[seg]) {
				return groups[seg][0];
			}
		});

		// compact the ordered array, and add the original param array
		// to it to include params that were not part the segmentOrder array
		let concated = _.compact(ordered).concat(paramArr);

		// return only unique objects in the array
		return _.uniq(concated, false, i => { return i.id });
	}
}